import { Component, OnInit, Input } from '@angular/core';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-modal-dialog',
  templateUrl: './modal-dialog.component.html',
  styleUrls: ['./modal-dialog.component.scss']
})
export class ModalDialogComponent implements OnInit {

  visible: boolean = false;
  @Input() visibleEvent: Subject<boolean>;
  private visibleAnimate = false;

  ngOnInit() {
    this.visibleEvent.subscribe(value => this.visible = value);
  }

  public show(): void {
    this.visible = true;
    setTimeout(() => (this.visibleAnimate = true), 100);
  }

  public hide(): void {
    this.visibleAnimate = false;
    setTimeout(() => (this.visible = false), 300);
  }

  public onContainerClicked(event: MouseEvent): void {
    if ((<HTMLElement>event.target).classList.contains('modal')) {
      this.hide();
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/modal-dialog/modal-dialog.component.ts